export default __webpack_public_path__ + "2d1dc7b5c904b9a91b6f7c16de2ef391.png";